import SearchBar from "../../../../../Common/SearchBar";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BundleHeaderLayout(props) {
  var searchValue = props.searchValue,
    onSearchChange = props.onSearchChange,
    internalWebview = props.internalWebview,
    config = props.config,
    isBundeOffers = props.isBundeOffers,
    redux = props.redux,
    router = props.router;
  return /*#__PURE__*/_jsx("div", {
    className: "flex flex-col lg:flex-row text-white gap-x-5 cursor-pointer",
    children: /*#__PURE__*/_jsxs("div", {
      className: "w-full ".concat(internalWebview ? "sticky top-0 z-10 bg-white py-1 " : ""),
      children: [/*#__PURE__*/_jsx("div", {
        className: "".concat(internalWebview ? "fixed top-0 z-10 w-[95%]  lg:w-[70%] pt-4 pb-1 bg-white" : ""),
        children: /*#__PURE__*/_jsx(SearchBar, {
          searchValue: searchValue,
          onSearchChange: onSearchChange,
          config: config,
          redux: redux,
          router: router
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden lg:block w-full h-full ".concat(internalWebview ? "mt-16" : "mt-4"),
        children: isBundeOffers && (config === null || config === void 0 ? void 0 : config.clientId) == "4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08" && /*#__PURE__*/_jsx("img", {
          className: "w-full h-full md:h-auto object-cover rounded-xl cursor-default",
          src: "https://cdn.loyalie.in/1729488243491_godrej-welcomegift-banner"
        })
      })]
    })
  });
}